module.exports = __webpack_public_path__ + "img/wind.0e770571.svg";